import {
    get,
} from "@insite/client-framework/Services/ApiService";

const categoryNavJsonApiUrl = "api/categorynavjson";

export async function getCategoryNavJson() {
    const geoApiResponse = await (await get<any>(`${categoryNavJsonApiUrl}`));
    return geoApiResponse;
}